import * as actionTypes from "../context/actionType";
import { IAction, IAppProviderContextProps } from "../interfaces";

const updateState = (
  state: IAppProviderContextProps,
  payload: any,
  key: string,
  isLoading: boolean = false
) => ({
  ...state,
  isLoading,
  [key]: payload,
});

const appReducer = (state: IAppProviderContextProps, action: IAction) => {
  switch (action.type) {
    case actionTypes.IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case actionTypes.STARTUP_DATA_SUCCESS:
      return updateState(state, action.payload, "startupData", true);

    case actionTypes.GAMBLING_CONTROL_SUCCESS:
      return updateState(state, action.payload, "gamblingBlock");

    case actionTypes.CMS_STATIC_CONTENT_SUCCESS:
      return updateState(state, action.payload, "cmsStaticContent");

    case actionTypes.SET_ERROR:
      return updateState(state, action.payload, "error");

    default:
      return state;
  }
};

export default appReducer;
